module.exports = __webpack_public_path__ + "media/images/users/boy-6b9096721c0b0ed1a464c829f269be66.svg";